export default "__VITE_ASSET__CbuJ45KO__"